import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { TextField, InputAdornment, Grid, IconButton } from '@mui/material';
import FilterCategories from './FilterCategories';
import { SearchIcon } from 'components/SVG';
import { useSparkSearchContext } from 'hooks/common/useSparkSearchContext';

type SparkMainAppSearchFiltersProps = {
  hideCategories?: boolean;
  placeholder?: string;
  onChange?: (query: string) => void;
};

function SparkMainAppSearchFilters({
  hideCategories = false,
  placeholder = '',
  onChange,
}: SparkMainAppSearchFiltersProps) {
  const [localQuery, setLocalQuery] = React.useState('');

  const {
    handleFilterButtonClick,
    handleQueryChange,
    getIsFilterButtonActive,
  } = useSparkSearchContext();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const query = e.target.value;
    setLocalQuery(query);
    handleQueryChange(query);
    onChange && onChange(query);
  };

  const handleCloseClick = () => {
    setLocalQuery('');
    handleQueryChange('');
  };

  return (
    <Grid
      container
      item
      display='flex'
      alignItems='center'
      gap={2}
      marginTop={2}
      md={12}
    >
      <Grid item container md={12} marginTop={2} flexWrap='nowrap'>
        <TextField
          placeholder={placeholder || 'Search Plugins'}
          sx={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #EEEEEE',
            borderRadius: '12px',
          }}
          autoComplete='off'
          fullWidth={true}
          onChange={handleChange}
          value={localQuery}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: !!localQuery.length && (
              <IconButton onClick={handleCloseClick}>
                <CloseIcon />
              </IconButton>
            ),
          }}
        />
      </Grid>
      {!hideCategories && (
        <FilterCategories
          filterButtonClick={handleFilterButtonClick}
          isFilterButtonActive={getIsFilterButtonActive}
        />
      )}
    </Grid>
  );
}

export default SparkMainAppSearchFilters;
